import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { TOOLS } from "@/lib/tools";

export default function ToolsIndex() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div data-testid="tools-index-page" className="min-h-screen bg-lw-ivory">
      <Nav />
      <main className="pt-28 sm:pt-32 lg:pt-36 pb-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="max-w-3xl">
            <span className="lw-eyebrow">Interactive Tools</span>
            <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-lw-navy leading-[1.05]">
              Six tools. <span className="italic">One clearer picture.</span>
            </h1>
            <p className="mt-5 text-base sm:text-lg text-lw-muted leading-relaxed">
              Education-first calculators that translate complex products into
              plain-English answers. No accounts, no sales pitch — just numbers
              and a recommendation you can act on.
            </p>
          </div>

          <div className="gold-hairline opacity-60 my-10" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {TOOLS.map(({ slug, name, blurb, duration, Icon, accent }) => (
              <Link
                to={`/tools/${slug}`}
                key={slug}
                data-testid={`tools-index-card-${slug}`}
                className="lw-card group p-7 flex flex-col h-full"
              >
                <div className="flex items-start justify-between mb-5">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                      accent === "gold"
                        ? "bg-lw-gold/15 text-[#8a6a2b]"
                        : "bg-lw-navy text-[#FAF8F3]"
                    }`}
                    aria-hidden="true"
                  >
                    <Icon size={22} />
                  </div>
                  <span className="lw-pill">{duration.replace("Takes ~", "")}</span>
                </div>
                <h2 className="font-serif-display text-xl sm:text-2xl text-lw-navy leading-tight">
                  {name}
                </h2>
                <p className="mt-2 text-sm text-lw-muted leading-relaxed flex-1">
                  {blurb}
                </p>
                <span className="mt-6 inline-flex items-center gap-1.5 font-sans-ui text-sm font-semibold text-lw-navy group-hover:text-[#8a6a2b] transition-colors">
                  Open tool
                  <ArrowRight
                    size={16}
                    className="transition-transform group-hover:translate-x-0.5"
                  />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
